/**
 * Conditional className joiner.
 *
 * Deliberately tiny — the app has no need for tailwind-merge's conflict
 * resolution, because component variants are written as complete class lists
 * rather than as overrides layered on top of each other.
 */
export type ClassValue = string | number | null | undefined | false | ClassValue[]

export function cn(...values: ClassValue[]): string {
  const out: string[] = []
  for (const value of values) {
    if (!value && value !== 0) continue
    if (Array.isArray(value)) {
      const nested = cn(...value)
      if (nested) out.push(nested)
    } else {
      out.push(String(value))
    }
  }
  return out.join(' ')
}
